import React from "react";
import {NavPanel} from './NavPanel';
export function NavPanelRow({NavPanels=[]}){
	return(
		<ul className={'dashboard-tabs nav nav-pills nav-danger row row-paddingless m-0 p-0 flex-column flex-sm-row'}>
			{NavPanels.map(((value, index) =>{
				const Icon = value.icon
					return <li key={index} className='nav-item d-flex col flex-grow-1 flex-shrink-0 mr-3 mb-3 mb-lg-0'><NavPanel link={value.link} text={value.text} icon={<Icon/>} /></li>
			}
			))}
		</ul>
	)
}